import request from '@/services/interceptor.js'

export const get_tipiManutenzione = () => {
    return request({
        url: '/tipomanutenzione',
        method: 'get',
        loadingBar: true
    })
}

export const get_tipoManutenzione = (id) => {
    return request({
        url: `/tipomanutenzione/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_tipoManutenzione = (par) => {
    return request({
        url: '/tipomanutenzione',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_tipoManutenzione = (id, par) => {
    return request({
        url: `/tipomanutenzione/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_tipoManutenzione = (id) => {
    return request({
        url: `/tipomanutenzione/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_tipoManutenzione = (id) => {
    return request({
        url: `/tipomanutenzione/${id}`,
        method: 'delete',
        loadingBar: true
    })
}